import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cms-footer',
  template: '<fin-footer />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsFooterComponent {
  constructor() {
    /* noop */
  }
}
